import * as React from 'react';
import styled, { keyframes, FlattenInterpolation } from 'styled-components';
import {
  SpaceProps,
  space,
  MinWidthProps,
  minWidth,
  WidthProps,
  HeightProps,
  MinHeightProps,
  minHeight,
  width,
  height,
} from 'styled-system';

import { colors } from '../../theme/colors';
import { themeGet, is } from '../../theme/utils';
import { iconsName } from './svgs/iconsName';
import * as svgs from './svgs/icons';

export type IconColors = keyof typeof colors | 'inherit';
export type IconNames = typeof iconsName[number];

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const IconWrapper = styled.span<
  SpaceProps &
    MinWidthProps &
    WidthProps &
    MinHeightProps &
    HeightProps & { color: IconColors; rotation: boolean; customCss?: FlattenInterpolation<any> }
>`
  ${space};
  ${width};
  ${minWidth};
  ${height};
  ${minHeight};
  box-sizing: border-box;
  position: relative;
  display: block;
  > svg {
    position: absolute;
    left: 0;
    top: 0;
    width: inherit;
    height: inherit;
    fill: ${({ color }) => (color && color !== 'inherit' ? themeGet.colors(color as any) : 'currentColor')};
  }
  ${is('rotation')`
    animation: ${rotate} 2s linear infinite;
  `}

  ${(props) => props.customCss}
`;

export interface IconProps {
  name: IconNames;
  size?: number;
  color?: IconColors;
  width?: string | string[];
  rotation?: boolean;
  className?: string;
}

export const Icon: React.FC<IconProps & { customCss?: FlattenInterpolation<any> }> = ({
  customCss,
  name,
  size,
  color = 'primary',
  width = '100%',
  rotation = false,
  className,
}) => {
  const SVG = svgs[name] || svgs['close'];
  const widthBySize = size ? `${size}px` : width;
  return (
    <IconWrapper
      className={className}
      rotation={rotation || name === 'spinner'}
      customCss={customCss}
      color={color}
      width={widthBySize}
      minWidth={widthBySize}
      height={widthBySize}
      minHeight={widthBySize}
    >
      <SVG />
    </IconWrapper>
  );
};

export { svgs };
